/* ==========================================================================
   S1B Wishlist — Client-side wishlist with localStorage + sync
   Externalized from s1b-wishlist.liquid for CSP compliance.
   ========================================================================== */
;(function () {
  'use strict'

  const STORAGE_KEY = 's1b_wishlist'
  const META_KEY = 's1b_wishlist_meta'
  const grid = document.getElementById('s1bWlGrid')
  const loading = document.getElementById('s1bWlLoading')
  const empty = document.getElementById('s1bWlEmpty')
  const countEl = document.getElementById('s1bWlCount')

  if (!grid) return

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []
    } catch (_) {
      return []
    }
  }
  function getMeta() {
    try {
      return JSON.parse(localStorage.getItem(META_KEY)) || {}
    } catch (_) {
      return {}
    }
  }
  function saveWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list))
    } catch (_) {}
  }
  function saveMeta(meta) {
    try {
      localStorage.setItem(META_KEY, JSON.stringify(meta))
    } catch (_) {}
  }

  function updateCount(n) {
    countEl.textContent = n === 1 ? '1 product saved' : n + ' products saved'
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '')
  }

  function renderCard(product) {
    const variant = product.variants[0]
    const img = product.featured_image ? product.featured_image.replace(/(\.[a-z]+)(\?|$)/, '_400x$1$2') : ''
    const price = variant ? variant.price : 0
    const comparePrice = variant ? variant.compare_at_price : 0
    const available = product.available

    const card = document.createElement('div')
    card.className = 's1b-wl__card'
    card.setAttribute('data-product-id', String(product.id))

    card.innerHTML =
      '<div class="s1b-wl__card-img-wrap">' +
      (img
        ? '<img class="s1b-wl__card-img" src="' +
          img +
          '" alt="' +
          (product.title || '').replace(/"/g, '&quot;') +
          '" loading="lazy" width="400" height="400">'
        : '') +
      '<button class="s1b-wl__card-remove" aria-label="Remove from wishlist" data-remove-id="' +
      product.id +
      '">' +
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
      '</button>' +
      '</div>' +
      '<div class="s1b-wl__card-body">' +
      (product.vendor ? '<p class="s1b-wl__card-vendor">' + product.vendor + '</p>' : '') +
      '<h3 class="s1b-wl__card-title"><a href="/products/' +
      product.handle +
      '">' +
      product.title +
      '</a></h3>' +
      '<p class="s1b-wl__card-price">' +
      formatMoney(price) +
      (comparePrice && comparePrice > price
        ? '<span class="s1b-wl__card-price--compare">' + formatMoney(comparePrice) + '</span>'
        : '') +
      '</p>' +
      '<button class="s1b-wl__card-atb"' +
      (available ? '' : ' disabled') +
      ' data-variant-id="' +
      (variant ? variant.id : '') +
      '">' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>' +
      (available ? 'Move to bag' : 'Sold Out') +
      '</button>' +
      '<p class="s1b-wl__card-error"></p>' +
      '</div>'

    return card
  }

  function removeFromWishlist(productId) {
    const list = getWishlist()
    const meta = getMeta()
    const idx = list.indexOf(String(productId))
    if (idx !== -1) list.splice(idx, 1)
    delete meta[String(productId)]
    saveWishlist(list)
    saveMeta(meta)

    /* Remove card from DOM with animation */
    const card = grid.querySelector('[data-product-id="' + productId + '"]')
    if (card) {
      card.style.transition = 'opacity 250ms cubic-bezier(0.33,1,0.68,1), transform 250ms cubic-bezier(0.33,1,0.68,1)'
      card.style.opacity = '0'
      card.style.transform = 'scale(0.95)'
      setTimeout(function () {
        card.remove()
        const remaining = getWishlist()
        updateCount(remaining.length)
        if (remaining.length === 0) {
          empty.hidden = false
        }
      }, 260)
    }

    /* Sync to Shopify metafield */
    const email = (function () {
      try {
        return JSON.parse(document.getElementById('s1b-customer-data').textContent).email
      } catch (_) {
        return null
      }
    })()
    if (email) {
      fetch(
        ((window.S1B_CONFIG && window.S1B_CONFIG.vi_endpoint) || 'https://vi.studio1beauty.com') + '/wishlist/sync',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: email, wishlist: list })
        }
      ).catch(function () {})
    }

    /* Update heart buttons elsewhere on page */
    document.querySelectorAll('.s1b-wishlist-btn[data-product-id="' + productId + '"]').forEach(function (btn) {
      btn.classList.remove('is-wishlisted')
    })
  }

  function addToBag(variantId, btn) {
    if (!variantId) return
    const errEl = btn.parentElement.querySelector('.s1b-wl__card-error')
    /* Polish-49 — Wishlist "Move to bag": on successful /cart/add.js,
       remove the item from the wishlist. Matches Ulta/Sephora "Move to
       Bag" semantics — the wishlist is a to-buy list, so once you've
       bought it, it doesn't belong there anymore. Card fades out via
       the existing removeFromWishlist animation. */
    const card = btn.closest('[data-product-id]')
    const productId = card ? card.getAttribute('data-product-id') : null
    btn.disabled = true
    btn.textContent = 'Adding...'

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Failed')
        return r.json()
      })
      .then(function () {
        btn.textContent = 'Moved'
        btn.style.background = 'var(--s1b-success, #1A1A1A)'
        /* Trigger cart update event for theme */
        document.dispatchEvent(new CustomEvent('cart:refresh'))
        /* Polish-49 — Remove from wishlist after a short visual-confirm
           delay so the user sees "Moved" before the card fades out. */
        setTimeout(function () {
          if (productId) {
            removeFromWishlist(productId)
          } else {
            /* Fallback: no productId resolved, restore button state. */
            btn.textContent = 'Move to bag'
            btn.style.background = ''
            btn.disabled = false
          }
        }, 600)
      })
      .catch(function () {
        btn.textContent = 'Move to bag'
        btn.disabled = false
        btn.style.background = ''
        if (errEl) {
          errEl.textContent = 'Could not add to bag. Try again.'
          errEl.style.display = 'block'
          setTimeout(function () {
            errEl.style.display = 'none'
          }, 4000)
        }
      })
  }

  /* Delegated click handlers */
  grid.addEventListener('click', function (e) {
    const removeBtn = e.target.closest('[data-remove-id]')
    if (removeBtn) {
      e.preventDefault()
      removeFromWishlist(removeBtn.getAttribute('data-remove-id'))
      return
    }
    const atbBtn = e.target.closest('.s1b-wl__card-atb')
    if (atbBtn && !atbBtn.disabled) {
      e.preventDefault()
      addToBag(atbBtn.getAttribute('data-variant-id'), atbBtn)
    }
  })

  /* Load products */
  function init() {
    const list = getWishlist()
    const meta = getMeta()

    if (!list.length) {
      loading.hidden = true
      empty.hidden = false
      updateCount(0)
      return
    }

    /* Collect handles from meta */
    const handles = []
    list.forEach(function (id) {
      if (meta[id] && meta[id].handle) handles.push({ id: id, handle: meta[id].handle })
    })

    if (!handles.length) {
      loading.hidden = true
      empty.hidden = false
      updateCount(0)
      return
    }

    updateCount(handles.length)

    /* Fetch each product via AJAX API */
    let fetched = 0
    let loaded = 0
    handles.forEach(function (item) {
      fetch('/products/' + item.handle + '.js')
        .then(function (r) {
          if (!r.ok) throw new Error('Not found')
          return r.json()
        })
        .then(function (product) {
          const card = renderCard(product)
          grid.appendChild(card)
          loaded++
        })
        .catch(function () {
          /* Product no longer available, silently skip */
        })
        .finally(function () {
          fetched++
          if (fetched === handles.length) {
            loading.hidden = true
            if (loaded === 0) {
              empty.hidden = false
              updateCount(0)
            } else {
              updateCount(loaded)
            }
          }
        })
    })
  }

  /* Run on DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
})()
